const uploadMessage = {
  click: 'Click or drag files here...',
  error: 'Unsupported file',
  success: 'Drop files here'
};

export default uploadMessage;
